import styled from "styled-components";

import { DayStyledProps as Props } from "./Day.types";

const DayStyled = styled.div<Props>`
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${props =>
    props.selected ? "var(--palette-primary)" : "transparent"};
  border-radius: 1.6rem;
  padding: 0.8rem;

  .Day {
    &__name {
      font-size: 1.4rem;
      font-weight: 600;
      color: ${props =>
        props.selected
          ? "var(--palette-mid-blue-s15-l20)"
          : "var(--palette-white)"};
    }

    &__number {
      font-size: 3.6rem;
      color: ${props =>
        props.selected
          ? "var(--palette-mid-blue-s15-l20)"
          : "var(--palette-white)"};
    }
  }
`;

export default DayStyled;
